import React from 'react'
import { clsx } from 'clsx'

interface PageHeaderProps {
  title: string
  subtitle?: string
  showBackButton?: boolean
  onBack?: () => void
  actions?: React.ReactNode
  statusIndicator?: {
    status: 'success' | 'warning' | 'error' | 'info'
    message: string
  }
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  showBackButton,
  onBack,
  actions,
  statusIndicator
}) => {
  return (
    <header className="bg-white border-b border-gray-200 px-4 py-3 safe-area-pt">
      <div className="flex items-center justify-between">
        <div className="flex items-center flex-1">
          {showBackButton && (
            <button
              onClick={onBack}
              className="mr-3 p-2 -ml-2 text-gray-600 hover:text-gray-900 touch-target"
              aria-label="กลับไปหน้าก่อน"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          
          <div className="flex-1">
            <h1 className="text-lg font-semibold text-gray-900 font-thai-header">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-gray-500 mt-0.5 font-thai">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        
        {actions && (
          <div className="flex items-center space-x-2">
            {actions}
          </div>
        )}
      </div>
      
      {statusIndicator && (
        <div className={clsx(
          'mt-3 p-3 rounded-lg text-sm',
          statusIndicator.status === 'success' && 'bg-green-50 text-green-700 border border-green-200',
          statusIndicator.status === 'warning' && 'bg-yellow-50 text-yellow-700 border border-yellow-200',
          statusIndicator.status === 'error' && 'bg-red-50 text-red-700 border border-red-200',
          statusIndicator.status === 'info' && 'bg-blue-50 text-blue-700 border border-blue-200'
        )}>
          {statusIndicator.message}
        </div>
      )}
    </header>
  )
}